<template>
  <v-dialog v-model="modelAddress" width="800px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="step == 0">
      <v-card-text class="pa-8">
        <v-row>
          <v-col cols="12" class="py-2 d-flex align-center">
            <b class="text-color-black text-xlarge">CADASTRAR ENDEREÇO</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="v-col-12 v-col-lg-7 pt-3 pb-5 d-flex align-center">
            <span class="text-color-0 text-small">Preencha os dados {{ dragged ? "restantes": "" }} do seu endereço: </span>
          </v-col>
          <v-col class="v-col-12 v-col-lg-5 pt-3 pb-5">
            <v-checkbox density="compact" v-model="formAddress.is_main_address" inline hide-details class="text-color-0 justify-end">
              <template v-slot:label>
                Definir como endereço principal
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-form ref="formaddress" lazy-validation>
					<v-row>
						<v-col class="v-col-12 py-1">
							<v-text-field variant="outlined" v-model="formAddress.nickname" label="Descrição" :rules="[rules.required]" placeholder="Ex: Minha Casa"></v-text-field>
						</v-col>
						<v-col cols="6" class="v-col-12 v-col-lg-6 py-1">
							<v-text-field ref="zipCode" variant="outlined" :loading="loading" v-model="formAddress.zip_code" label="CEP" v-maska:[masks.cep] :rules="[rules.required, rules.minMaxCep]" :disabled="disabled.zip_code" placeholder="Ex: 00000-000" @keyup="findCep()"></v-text-field>
						</v-col>
						<v-col class="v-col-12 v-col-lg-6 py-1">
							<v-select v-model="formAddress.state" label="Estado" :items="estados" :rules="[rules.required]" :disabled="disabled.state" item-title="descricao" item-value="sigla"></v-select>
						</v-col>
						<v-col class="v-col-12 py-1">
							<v-text-field variant="outlined" v-model="formAddress.street" label="Rua" :rules="[rules.required]" :disabled="disabled.street" placeholder="Ex: Rua das Flores"></v-text-field>
						</v-col>
						<v-col class="v-col-12 v-col-lg-6 py-1">
							<v-text-field variant="outlined" v-model="formAddress.num" label="Número" :rules="[rules.required]" placeholder="Ex: 123"></v-text-field>
						</v-col>
						<v-col class="v-col-12 v-col-lg-6 py-1">
							<v-text-field variant="outlined" v-model="formAddress.district" label="Bairro" :rules="[rules.required]" :disabled="disabled.district" placeholder="Qual o seu bairro?"></v-text-field>
						</v-col>
						<v-col class="v-col-12 v-col-lg-6 py-1">
							<v-text-field variant="outlined" v-model="formAddress.city" label="Cidade" :rules="[rules.required]" :disabled="disabled.city" placeholder="Qual a sua cidade?"></v-text-field>
						</v-col>
						<v-col class="v-col-12 v-col-lg-6 py-1">
							<v-text-field variant="outlined" v-model="formAddress.complement" label="Complemento" placeholder="Ex: Residência"></v-text-field>
						</v-col>
					</v-row>
				</v-form>
        <v-row v-if="dragged == false">
          <v-col class="pb-2 pt-5">
            <v-btn variant="flat" block size="x-large" class="bg-color-2 text-color-white" :loading="loading" @click="validForm()">Continuar</v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="pb-2 pt-5">
            <v-btn variant="flat" block size="x-large" class="bg-color-0 text-color-white" :loading="loading" @click="voltar()">Voltar para o Mapa</v-btn>
          </v-col>
          <v-col class="pb-2 pt-5">
            <v-btn variant="flat" block size="x-large" class="bg-color-2 text-color-white" :loading="loading" @click="validForm()">Concluir</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="step == 1">
      <v-card-text class="pa-8">
        <div class="w-100" style="height: 500px;">
          <v-btn class="geolocate" @click="geolocate();"><v-icon icon="mdi-target" class="me-2"></v-icon> Minha Localização</v-btn>
          <v-btn class="local-voltar d-none d-sm-block" :loading="loading" @click="step = 0">Voltar</v-btn>
          <v-btn size="large" class="local-confirm bg-color-2 text-color-white text-large" :loading="loading" :disabled="zoom <= 15" @click="confirmar();">Confirmar Localização</v-btn>
          <div class="pin">
            <div v-if="pinup == false" class="map-tooltip">
              <div class="map-arrow"></div>
              Você está aqui?<br>
              <span class="text-xsmall text-color-0">Arraste para ajustar</span>
            </div>
            <img src="../assets/images/pin.png" :class="pinup == true ? 'pin-up': ''">
            <div class="pin-shadow"></div>
          </div>
          <LMap ref="mappin" :zoom="zoom" :minZoom="5" :center="center" :options="{ scrollWheelZoom: 'center' }" style="height: 500px; width: 100%" @update:center="centerChange" @update:zoom="zoomChange" @drag="pinup = true;" @dragend="pinup = false;">
            <LTileLayer :url="url" :attribution="attribution" />
          </LMap>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { LMap, LTileLayer } from "@vue-leaflet/vue-leaflet";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
export default {
  name: 'DialogAddressRegister',
  components: {
    LMap,
    LTileLayer
  },
  data(){
    return {
      modelAddress: false,
      loading: false,
      step : 0,
      pinup: false,
			formAddress: {
				id: null,
				is_main_address: false,
				nickname: "",
				street: "",
				num: "",
				zip_code: "",
				district: "",
				city: "",
				state: "",
				complement: ""
			},
      disabled: {
        street: false,
				zip_code: false,
				district: false,
				city: false,
				state: false,
      },
      masks: {
        cep: {
          mask: "#####-###",
        },
      },
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
        minMaxCep: v => (v && v.length == 9) || 'Este campo deve conter 9 caracteres.',
      },
      zoom: 16,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      options: {
        zoomControl: false,
        rotateControl: false,
        scaleControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        clickableIcons: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy"
      },
      icon: L.icon({
        iconUrl: '../assets/images/pin.png',
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      }),
      center: { lat: 0, lng: 0 },
      dragged: false
    }
  },
  props: {
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    },
    address: {
      type: Object,
      default: null
    },
    register: {
      type: Function,
      default: null
    },
    confirm: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    model() {
      this.dragged = false;
      this.modelAddress = this.model;
      if(this.address == null){
        this.clearForm();
      } else {
        this.disableFields();
      }
      if (this.modelAddress && this.register) {
        this.getLatLon();
      }
      if(this.modelAddress && this.confirm){
        this.getLatLon();
      }
    },
    address(){
      if(this.address != null){
        this.formAddress.id = this.address.address_id;
        this.formAddress.is_main_address = this.address.is_main_address;
        this.formAddress.nickname = this.address.address_nickname;
        this.formAddress.street = this.address.street;
        this.formAddress.num = this.address.num;
        this.formAddress.zip_code = this.address.zip_code;
        this.formAddress.district = this.address.district;
        this.formAddress.city = this.address.city;
        this.formAddress.state = this.address.state;
        this.formAddress.complement = this.address.complement;
      } else {
        this.formAddress.id = null;
        this.formAddress.is_main_address = false;
        this.formAddress.nickname = "";
        this.formAddress.street = "";
        this.formAddress.num = "";
        this.formAddress.zip_code = "";
        this.formAddress.district = "";
        this.formAddress.city = "";
        this.formAddress.state = "";
        this.formAddress.complement = "";
      }
      if (this.modelAddress) {
        this.disableFields();
      }
    }
  },
  computed: {
    ...mapState('main', {
      estados: 'estados'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig',
    }),
    canEditAddress() {
      return this.getConfig?.storeConfig?.is_address_edit === 1;
    }
  },
  methods: {
    ...mapActions('user', {
      registerAddress: 'registerAddress',
      updateAddress: 'updateAddress',
      addressZipCode: 'addressZipCode',
      geoLocationByAddress: 'geoLocationByAddress',
      addressByGeoLocation: 'addressByGeoLocation',
      changeAddress: 'changeAddress'
    }),
    voltar(){
      this.step = 1;
    },
    findCep(){
      if(this.formAddress.zip_code.length == 9){
        this.loading = true;
        this.addressZipCode(this.formAddress.zip_code.replace("-", "")).then(function(response){
          if(response){
            this.formAddress.street = response.street;
            this.formAddress.district = response.district;
            this.formAddress.city = response.city;
            this.formAddress.state = response.state;
            this.formAddress.complement = response.complement;
          } else {
            this.formAddress.street = "";
            this.formAddress.district = "";
            this.formAddress.city = "";
            this.formAddress.state = "";
            this.formAddress.complement = "";
          }
          this.loading = false;
        }.bind(this));
      }
    },
    clearForm(){
      this.formAddress.nickname = "";
      this.formAddress.street = "";
      this.formAddress.num = "";
      this.formAddress.zip_code = "";
      this.formAddress.district = "";
      this.formAddress.city = "";
      this.formAddress.state = "";
      this.formAddress.complement = "";
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition(position => {
        this.dragged = true;
        this.center = { lat: position.coords.latitude, lng: position.coords.longitude };
      });
    },
    zoomChange(zoom){
      this.zoom = zoom;
    },
    centerChange(center){
      this.dragged = true;
      this.center = center;
    },
    async validForm(){
      const { valid } = await this.$refs.formaddress.validate();
      if (valid){
        if(this.dragged){
          this.cadastrar();
        } else {
          this.getLatLon();
        }
      }
    },
    getLatLon(){
      this.loading = true;
      this.geoLocationByAddress({ "zip_code": this.formAddress.zip_code, "street": this.formAddress.street, "number": this.formAddress.num, "district": this.formAddress.district, "city": this.formAddress.city, "state": this.formAddress.state }).then(function(response){
        if(response.cod == 100){
          this.center.lat = response.return.lat;
          this.center.lng = response.return.lon;
          this.step = 1;
        } else {
          this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg});
        }
        this.loading = false;
      }.bind(this));
    },
    confirmar(){
      if(this.dragged){
        this.loading = true;
        this.addressByGeoLocation({ lat: this.center.lat, lon: this.center.lng }).then(function(response){
          if(response.cod == 100){
            this.formAddress.zip_code = response.return.zip_code;
            this.formAddress.street = response.return.street != "" ? response.return.street: this.formAddress.street;
            this.formAddress.district = response.return.district != "" ? response.return.district: this.formAddress.district;
            this.formAddress.city = response.return.city;
            this.formAddress.state = response.return.state;
            this.disableFields();
            this.step = 0;
          } else {
            this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg});
          }
          this.loading = false;
        }.bind(this));
      } else {
        this.cadastrar();
      }
    },
    disableFields(){
      const cep = this.formAddress.zip_code?.split("-");
      const isFirstAddress = this.address == null;
      const isEditable = isFirstAddress || this.canEditAddress === true;
    
      this.disabled.zip_code = !isEditable;
      this.disabled.district = !isEditable;
      this.disabled.city = !isEditable;
      this.disabled.state = !isEditable;
      this.disabled.street = !isEditable || (cep && cep[1] === "000");
    },
    cadastrar(){
      this.formAddress.lat = this.center.lat;
      this.formAddress.lon = this.center.lng;
      if(this.register != null){
        this.register(this.formAddress);
      } else {
        if(this.formAddress.id != null){
          this.updateAddress(this.formAddress).then(function(response){
            this.clearForm();
            this.fechar();
            this.dragged = false;
            this.disableFields();
            this.emitter.emit('dialogMessage', { title: response.cod == 200 ? "Sucesso!": "Ops!", message: response.msg});
          }.bind(this));
        } else {
          this.registerAddress(this.formAddress).then(function(response){
            this.emitter.emit('dialogMessage', { title: response.cod == 200 ? "Sucesso!": "Ops!", message: response.msg});
            if(response.return.area != null){
              this.changeAddress({ destiny_type: 1, destiny_id: response.return.address_id } ).then(function(){
                this.clearForm();
                this.fechar();
                this.dragged = false;
                this.disableFields();
              }.bind(this));
            } else {
              this.clearForm();
              this.fechar();
              this.dragged = false;
              this.disableFields();
              this.emitter.emit('dialogMessage', { title: 'Ops!', message: this.getConfig.storeConfig.min_withdrawal_value_order >= 0 ? 'Infelizmente não efetuamos entrega para este endereço. Por favor, verifique se o endereço está correto ou retire suas compras em nossa unidade.' : 'Infelizmente não efetuamos entrega para este endereço. Por favor, verifique se o endereço está correto.' });
            }
          }.bind(this));
        }
      }
    }
  }
}
</script>